/* eslint-disable camelcase */
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import CustomModal from '../../components/modal/Modal';
import DokanIcons from '../../components/icon/DokanIcons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function WithdrawCancel({
    handleCancelModal,
    showCancel,
    setShowCancel,
    handleCancelWithdraw,
    tiny_loader,
}) {
    return (
        <>
            <CustomModal title="" onClose={handleCancelModal} show={showCancel}>
                <Spin indicator={antIcon} spinning={tiny_loader} tip="canceling...">
                    <div className="flex flex-col gap-3 justify-center items-center">
                        <div>
                            <DokanIcons icon="#cancel_bag" size={9} />
                        </div>
                        <div className="text-semi-lg text-center p-4 max-w-full">
                            Do you really want to cancel the withdraw request?
                        </div>
                        <div className="flex space-x-6">
                            <div>
                                <button
                                    onClick={() => setShowCancel(false)}
                                    type="button"
                                    className="py-3 px-8 bg-white border border-gray-400 text-dark font-semibold rounded-md"
                                >
                                    No
                                </button>
                            </div>
                            <div>
                                <button
                                    onClick={handleCancelWithdraw}
                                    type="button"
                                    className="py-3 px-5  bg-orange border border-orange text-white font-semibold rounded-md"
                                >
                                    Yes, Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Spin>
            </CustomModal>
        </>
    );
}

export default WithdrawCancel;
